
import { defineComponent } from "vue";
import { Image } from "@/types";
import { DataStation } from "@/types/datastation.type";
import { getDataEnvironmental } from "@/service/datastation.service";
import StationImagesModalComponent from "./StationImagesModal.component.vue";
import { Filter } from "@/types/filter.type";
import { getParameter } from "@/service/parameter.service";
import { ElRowClassNameParams } from "@/types/element.type";
import ImageCameraComponent from "./camera/ImageCamera.component.vue";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { i18n } from "@/plugins/i18n.plugin";

interface DataItem {
  id: number;
  code: string | undefined;
  magnitude: string | undefined;
  measurement: string | undefined;
  unit: string | undefined;
}

export default defineComponent({
  components: { ImageCameraComponent, StationImagesModalComponent },
  props: {
    date: {
      type: String,
      required: true,
    },
    lastImage: {
      type: Object as () => Image | undefined,
      required: true,
    },
    station: {
      type: String,
      required: true,
    },

    onParameterClick: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const store = useStore<RootState>();
    return { store };
  },
  data() {
    return {
      count: 0,
      numData: 5,
      environmentalData: [] as DataStation[],
      dataTable: [] as DataItem[],
      isModalImageVisible: false,
      //stationCopy: {} as Station,
    };
  },
  // computed: {
  //   stationCopy(): Station {
  //     return this.store.state.station.station;
  //   },
  // },
  async mounted() {
    this.environmentalData = await getDataEnvironmental(this.station);
    this.getDataTable();
  },
  methods: {
    checkMagnitude() {
      this.count++;

      return this.count < this.numData ? true : false;
    },
    async getDataTable() {
      const parameters = await this.getAllEnvironmental();

      if (this.environmentalData) {
        for (let parameter of parameters) {
          const index = this.environmentalData.findIndex((_) => _.magnitude === parameter.code);
          let dataItem: DataItem = {} as DataItem;
          dataItem.unit = parameter.unit !== null ? parameter.unit : "";
          dataItem.code = parameter.code;
          if (index === -1) {
            dataItem.magnitude = !this.$t(`magnitude.${parameter.code}`).includes("magnitude")
              ? this.$t(`magnitude.${parameter.code}`)
              : parameter.name;
            dataItem.measurement = `-- ${dataItem.unit}`;
          } else {
            const data = this.environmentalData[index];
            dataItem.magnitude = !this.$t(`magnitude.${parameter.code}`).includes("magnitude")
              ? this.$t(`magnitude.${parameter.code}`)
              : parameter.name;

            // Dar formato decimal a valores numéricos
            if (!this.isTextMaasurement(data.measurement)) {
              // dataItem.measurement = `${i18n.global.n(Number(data.measurement), "rounded")} ${
              dataItem.measurement = `${i18n.global.n(Number(data.measurement), "fixed")} ${
                dataItem.unit
              }`;
            } else {
              dataItem.measurement = `${data.measurement} ${dataItem.unit}`;
            }
          }
          this.dataTable.push(dataItem);
        }
      }
    },
    // getUnitEnvironmental(magnitude: string) {
    //   let unit = "";
    //   if (datastation.magnitude === "luminosity") {
    //     unit = "Lumenes";
    //   } else if (datastation.magnitude === "temp_ext" || datastation.magnitude === "temp_water") {
    //     unit = "ºC";
    //   } else if (datastation.magnitude === "atmospheric_pressure") {
    //     unit = "kPa ";
    //   } else if (datastation.magnitude === "humidity_ext") {
    //     unit = "% ";
    //   } else if (datastation.magnitude === "distance_water") {
    //     unit = "mm";
    //   } else if (datastation.magnitude === "angle") {
    //     unit = "º";
    //   }

    //   return unit;
    // },
    getMagnitude(magnitude: string | undefined) {
      return !this.$t(`magnitude.${magnitude}`).includes("magnitude")
        ? this.$t(`magnitude.${magnitude}`)
        : magnitude;
    },

    closeModalImage() {
      this.isModalImageVisible = false;
    },

    seeImages() {
      if (this.station) {
        this.isModalImageVisible = true;
      }
    },

    async getAllEnvironmental() {
      const filter: Filter = {
        fields: {
          "parameter.active": { operator: "equal", value: true },
          "parameter.subtype": { operator: "equal", value: "ENVIRONMENTAL" },
        },
      };
      const parametersPagination = await getParameter(undefined, undefined, filter);
      return parametersPagination.data;
    },

    tableRowClassName(params: ElRowClassNameParams<DataItem>) {
      return params.row.measurement?.includes("--") ||
        params.row.code === "gps" ||
        params.row.code === "angle"
        ? ""
        : "pointer";
    },
    isTextMaasurement(measurement: string): boolean {
      const onlyNumbers = /^\d+(\.\d+)?$/;
      return !onlyNumbers.test(measurement);
    },
  },
});
